module.exports = __webpack_public_path__ + "img/poland.3eb06960.svg";